import { SFC } from 'react'
import OriginalContainer from 'reactstrap/lib/Container'

interface ContainerProps {
  tag?: React.ReactType
  fluid?: boolean
  className?: string
}

export const Container = OriginalContainer as SFC<ContainerProps>



// WEBPACK FOOTER //
// ./src/modules/flex-layout/container.tsx